const ENV = {
  rappi: {
    url: {
      CO: 'https://services.rappi.com',
      MX: 'https://services.mxgrability.rappi.com',
      BR: 'https://services.rappi.com.br',
      AR: 'https://services.rappi.com.ar',
      CL: 'https://services.rappi.cl',
      UY: 'https://services.rappi.com.uy',
      PE: 'https://services.rappi.pe',
      EC: 'https://services.rappi.com.ec',
      CR: 'https://services.rappi.co.cr',
      DEV: 'https://microservices.dev.rappi.com',
      LOCAL: 'http://0.0.0.0:9090',
    },
    baseAssets: 'https://img.rappi.com/web',
    storekeeper: {
      image: {
        CO: 'http://v2.grability.rappi.com/uploads/storekeepers',
        MX: 'http://v2.mxgrability.rappi.com/uploads/storekeepers',
        BR: 'http://v2.rappi.com.br/uploads/storekeepers',
        AR: 'http://v2.rappi.com.ar/uploads/storekeepers',
        CL: 'http://v2.rappi.cl/uploads/storekeepers',
        UY: 'http://v2.rappi.com.uy/uploads/storekeepers',
        PE: 'http://v2.rappi.pe/uploads/storekeepers',
        EC: 'http://v2.rappi.com.ec/uploads/storekeepers',
        CR: 'http://v2.rappi.co.cr/uploads/storekeepers',
        DEV: 'http://dev.grability.rappi.com/uploads/storekeepers',
      },
    },
  },
  zendesk: {
    createdBy: 'support-webapp',
    prod: {
      baseUrl: 'https://rappicall.zendesk.com',
      customFields: {
        orderId: 39842548,
        tipoSolucion: 360003012294,
        productos: 360003012274,
        storeType: 360002172794,
        createdBy: 360008664374,
        pais: 40558227,
      },
    },
    sandbox: {
      baseUrl: 'https://rappicall1563889421.zendesk.com',
      customFields: {
        orderId: 360023047174, //  bien
        tipoSolucion: 360023045914, //  bien
        productos: 360023059473, // verificar toString
        storeType: 360023047314, //  bien
        createdBy: 360023045314, //  bien
        pais: 360023057373, //  bien
      },
    },
  },
  kustomer: {
    prod: {
      chatFormId: '5e2b8748fb2a0c008e8ea3e6',
    },
    sandbox: {
      chatFormId: '5e2f472491dc810096db241f'
    }
  },
  firebase: {
    DEV: {
      apiKey: 'AIzaSyAh8254LV3hM66lOdtuQwaLH1G8lDdPGDQ',
      authDomain: 'rappi-dev-3c0ac.firebaseapp.com',
      projectId: 'rappi-dev-3c0ac',
      storageBucket: 'rappi-dev-3c0ac.appspot.com',
      messagingSenderId: '1010478840098',
      appId: '1:1010478840098:web:23e8b6df7bd6d6ab',
      measurementId: "G-G1FD954DG9"
    },
    PROD: {
      apiKey: "AIzaSyBQHtCm38tX_Oxr_tJo5pY-X7Ko6vEIVKg",
      authDomain: "project-6449085487294594863.firebaseapp.com",
      projectId: "project-6449085487294594863",
      storageBucket: "project-6449085487294594863.appspot.com",
      messagingSenderId: "160040612199",
      appId: "1:160040612199:web:ea8594db9ad176e18dffc2",
      measurementId: "G-QYFJWBCLT7"
    }
  },
  compensationEnabled: {
    name: 'orderCompensationEnabled',
    value: true,
    group: 'ticketAutomation'
}
}

export default ENV
